export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Security',
      description: 'Military-grade encryption protects your data from hackers, ISPs, and government surveillance with AES-256 encryption standard.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Lightning Fast',
      description: 'Optimized servers ensure blazing-fast connection speeds without compromising your security or privacy while browsing.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Network',
      description: 'Access content from anywhere with our worldwide server network spanning multiple countries and continents.'
    },
    {
      icon: 'ri-lock-line',
      title: 'Zero-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activity remains completely anonymous and private.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Complete Privacy',
      description: 'Hide your IP address and encrypt your internet traffic to browse anonymously without leaving digital footprints.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Platform',
      description: 'Protect all your devices with native apps for Windows, Mac, iOS, Android, and Linux operating systems.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Why Choose Our VPN</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experience the ultimate protection with features designed for your security and privacy
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
